type Handler = (path: string) => void

let handler: Handler | null = null

export function startRouter(next: Handler): void {
  handler = next
  window.addEventListener('popstate', () => handler?.(location.pathname))
  handler(location.pathname)
}

export function navigate(path: string, options: { replace?: boolean } = {}): void {
  if (options.replace) {
    history.replaceState(null, '', path)
  } else {
    if (path === location.pathname) return
    history.pushState(null, '', path)
  }
  handler?.(path)
}

/**
 * Re-runs the current route from scratch. `navigate` short-circuits when the
 * path hasn't changed, which is right for links and wrong after something has
 * rewritten what the page is showing.
 */
export function reload(): void {
  handler?.(location.pathname)
}

/** Intercepts plain left-clicks on internal links so they don't reload the app. */
export function internalLink(path: string): Record<string, string | EventListener> {
  return {
    href: path,
    onclick: (event: Event) => {
      const mouse = event as MouseEvent
      if (mouse.metaKey || mouse.ctrlKey || mouse.shiftKey || mouse.altKey || mouse.button !== 0) return
      event.preventDefault()
      navigate(path)
    },
  }
}
